import { startOfToday, startOfYear, subYears } from 'date-fns';
import { MessageDescriptor } from 'react-intl';
import commonCalendarMessages from '../messages/common-messages/common-calendar.messages';
import { RangeDate } from '../model';

export const getFirstDayOfYear = (): Date => {
  return startOfYear(getToday());
};

export const getToday = (): Date => {
  return startOfToday();
};

export const getRangeFromStartYearToToday = (): RangeDate => {
  return {
    from: getFirstDayOfYear(),
    to: getToday(),
  };
};

export const getRangeLastYear = (): RangeDate => {
  return {
    from: subYears(getToday(), 1),
    to: getToday(),
  };
};

const weekdaysShortNames: MessageDescriptor[] = [
  commonCalendarMessages.mondayShort,
  commonCalendarMessages.tuesdayShort,
  commonCalendarMessages.wednesdayShort,
  commonCalendarMessages.thursdayShort,
  commonCalendarMessages.fridayShort,
  commonCalendarMessages.saturdayShort,
  commonCalendarMessages.sundayShort,
];

export const getWeekdaysShortNames = (startFromMonday = true) => {
  if (!startFromMonday) {
    return [
      commonCalendarMessages.sundayShort,
      ...weekdaysShortNames.slice(0, 6),
    ];
  }
  return weekdaysShortNames;
};

export const monthNames: MessageDescriptor[] = [
  commonCalendarMessages.january,
  commonCalendarMessages.february,
  commonCalendarMessages.march,
  commonCalendarMessages.april,
  commonCalendarMessages.may,
  commonCalendarMessages.june,
  commonCalendarMessages.july,
  commonCalendarMessages.august,
  commonCalendarMessages.september,
  commonCalendarMessages.october,
  commonCalendarMessages.november,
  commonCalendarMessages.december,
];
